import {HttpClient, HttpHeaders} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../environments/environment';

export function toV4ApiBase(v3Base: string): string {
  return v3Base.replace(/\/$/, '').replace(/\/v3$/, '/v4');
}

export interface V4Response<T> {
  code: number;
  message?: string;
  result: T | null;
}

@Injectable({
  providedIn: 'root',
})
export class V4HttpClient {
  private readonly http = inject(HttpClient);

  get publicAccountBaseUrl(): string {
    return `${toV4ApiBase(environment.apiBaseUrl)}/account`;
  }

  post<T>(url: string, body: unknown, headers?: HttpHeaders): Promise<V4Response<T>> {
    return firstValueFrom(
      this.http.post<V4Response<T>>(url, body, headers ? {headers} : {}),
    );
  }
}
